import { css } from 'styled-components';
import { Hr, COLORS, SPACINGS } from '@figure/figure-frontlib-gui';

export const Divider = () => (
  <Hr
    $css={css`
      // Negative margin require to extend past parent padding
      margin: ${SPACINGS.X2L}px -${SPACINGS.X2L}px;
      border-color: ${COLORS.NEUTRAL_250};
      border-style: solid;
    `}
  />
);
